
export default function QuestionTypeIconView() {
    let color = "";
    let text = "";
    let textIcon = "";
    return {
        oninit: (vnode) => {
           
        },
        view: (vnode) => {
            if (vnode.attrs.question.questionType.code == "0001")//text
            {
                color = "#1E85F1";
                text = "T";
                textIcon = "";
            }
            else if (vnode.attrs.question.questionType.code == "0002")//Singlr
            {
                color = "#191C25";
                text = "S";
                textIcon = "";
            }
            else if (vnode.attrs.question.questionType.code == "0003")//Multiple
            {
                color = "#8A8DA0";
                text = "M";
                textIcon = "";
            }
            else if (vnode.attrs.question.questionType.code == "0004")//Photo
            {
                color = "#84E0BE";
                text = "P";
                textIcon = "";
            }
            else if (vnode.attrs.question.questionType.code == "0005")// Number
            {
                color = "#F9AC19";
                text = "N";
                textIcon = "";
            }
            else if (vnode.attrs.question.questionType.code == "0006")//Date
            {
                color = "#FA4942";
                text = "D";
                textIcon = "";
            }
            else if (vnode.attrs.question.questionType.code == "0007")//GPS
            {
                color = "#F38068";
                text = "G";
                textIcon = "";
            }
            else if (vnode.attrs.question.questionType.code == "0008")//Single Dropdown
            {
                color = "#F38068";
                text = "S";
                textIcon = "bi-arrow-down";
            }
            else if (vnode.attrs.question.questionType.code == "0009")//Multi Dropdown
            {
                color = "#5BB971";
                text = "M";
                textIcon = "bi-arrow-down";
            }
            else if (vnode.attrs.question.questionType.code == "0010")//Barcode
            {
                color = "#B79D63";
                text = "B";
                textIcon = "";
            }
            else if (vnode.attrs.question.questionType.code == "0011")//YesNo
            {
                color = "#A69DB9";
                text = "Y";
                textIcon = "";
            }
            else if (vnode.attrs.question.questionType.code == "0012")//Rating
            {
                color = "#96CAFE";
                text = "R";
                textIcon = "";
            }
            return [
                textIcon == "" && m('.badge.colorRound-Q[title="'+vnode.attrs.question.questionType.name+'"]', { "style": "background-color:" + color }, text),
                textIcon != "" && m('.badge.colorRound-Q[title="'+vnode.attrs.question.questionType.name+'"]', { "style": "font-size:13px;padding-top:5px;background-color:" + color },
                    m('span', m('i.bi', { "class": textIcon, "style": "margin-right:0" }), text)
                )
                // textIcon == "" &&  m('span.span-badge',{ "style": "color:white;background-color:" + color }, text),
                // textIcon != "" &&  m('span.span-badge',{ "style": "color:white;background-color:" + color }, text),
                // textIcon == "" && m('.badge.colorRound-Q[title="'+vnode.attrs.question.questionType.name+'"]', { "style": "background-color:" + color }, text),
                // textIcon != "" && m('.badge.colorRound-Q[title="'+vnode.attrs.question.questionType.name+'"]', { "style": "font-size:13px;padding-top:5px;background-color:" + color },
                //     m('span', m('i.bi', { "class": textIcon, "style": "margin-right:0" }), text)
                // )
            ]
        }
    }
}